import { render, staticRenderFns } from "./Yousty.vue?vue&type=template&id=94aad866&scoped=true"
import script from "./Yousty.vue?vue&type=script&lang=js"
export * from "./Yousty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94aad866",
  null
  
)

export default component.exports